import { Navigate } from 'react-router-dom';

import { firstAuthorizedPath } from '@/config/nav-permissions';
import { usePermissions } from '@/hooks/use-permissions';
import { AdminHomePage } from '@/pages/admin/home';

/**
 * Accueil adapté au métier (8.3). L'accueil consolidé s'appuie sur
 * `/admin/reporting/home` (permission FINANCE.READ) : Direction et Finance le
 * voient. Les autres profils (Logistique, Support, …) sont redirigés vers leur
 * première page autorisée plutôt que sur un accueil indisponible (403).
 */
export function HomeGate() {
  const { has, hasAny } = usePermissions();
  if (has('FINANCE.READ')) return <AdminHomePage />;
  return <Navigate to={firstAuthorizedPath(hasAny)} replace />;
}
